import React from "react";

const Card = (props) => {
  const { className, headerClassName, footerClassName, bodyClassName, ...rest } = props
  return (
    <div className={"card " + className} {...rest}>
      {props.title && <div className={"card-header " + headerClassName}>
        <h3 className="card-title">{props.title}</h3>
      </div>
      }
      {props.children && <div className={"card-body " + bodyClassName}>{props.children}</div>}
      {props.footer && <div className={"card-footer " + footerClassName}>{props.footer}</div>}
    </div>
  );
};

Card.defaultProps = {
  title: "",
  children: "",
  footer: ""
}

export default Card;